export const messages = {
  en: {
    contractCreateFee: {
      search: {
        title: 'Search Conditions',
        contractCode: 'Contract Code',
        contractNameLike: 'Contract Name',
        contractType: 'Contract Type'
      },
      list: {
        title: 'Contract Information',
        batchCreate: 'Batch Create'
      },
      table: {
        contractCode: 'Contract Code',
        parentContractCode: 'Parent Contract Code',
        contractName: 'Contract Name',
        contractType: 'Contract Type',
        partyB: 'Party B',
        amount: 'Amount',
        startTime: 'Start Time',
        endTime: 'End Time',
        operation: 'Operation',
        payFee: 'Pay Fee',
        viewDetail: 'Detail',
        viewFee: 'View Fee'
      },
      fetchError: 'Failed to fetch contract data',
      enterContractCode: 'Enter contract code',
      enterContractName: 'Enter contract name',
      enterContractType: 'Enter contract type',
      enterPartyB: 'Enter party B',
      selectContractStatus: 'Select contract status',
      batchPayFee: 'Batch Pay Fee',
      batchCreate: 'Batch Create'
    },
    contractDetailFee: {
      temporaryFee: 'Temporary Fee',
      createFee: 'Create Fee',
      batchPayFee: 'Batch Pay Fee',
      prePayFee: 'Pre Pay Fee',
      payArrears: 'Pay Arrears',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      receivableAmount: 'Receivable Amount',
      accountingTime: 'Accounting Time',
      receivablePeriod: 'Receivable Period',
      description: 'Description',
      status: 'Status',
      operation: 'Operation',
      payment: 'Payment',
      paymentHistory: 'Payment History',
      cancel: 'Cancel',
      end: 'End',
      change: 'Change',
      previousReading: 'Previous Reading',
      currentReading: 'Current Reading',
      unitPrice: 'Unit Price',
      surcharge: 'Surcharge',
      usage: 'Usage',
      algorithm: 'Algorithm',
      feeBasedOnActual: 'Fee based on actual',
      fixedFee: 'Fixed Fee',
      note1: 'Note: Fees can be paid individually or in batch',
      note2: 'Note: Batch payment is more efficient',
      arrearsSubtotal: 'Arrears Subtotal'
    },
    feeDetailContractFeeRule: {
      createFee: 'Create Fee',
      tempFee: 'Temporary Fee',
      ruleId: 'Rule ID',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      createTime: 'Create Time',
      validity: 'Validity',
      formula: 'Formula',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional Fee',
      status: 'Status',
      valid: 'Valid',
      invalid: 'Invalid',
      billDate: 'Bill Date',
      billCycle: 'Bill Cycle',
      monthly: 'Monthly',
      operation: 'Operation',
      change: 'Change',
      manualFinish: 'Manual Finish',
      cancel: 'Cancel'
    },
    simplifyContractFee: {
      batchPayFee: 'Batch Pay Fee',
      prePayFee: 'Pre Pay Fee',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      receivableAmount: 'Receivable Amount',
      accountingTime: 'Accounting Time',
      receivablePeriod: 'Receivable Period',
      description: 'Description',
      status: 'Status',
      operation: 'Operation',
      payment: 'Payment',
      paymentHistory: 'Payment History',
      cancel: 'Cancel',
      end: 'End',
      change: 'Change',
      previousReading: 'Previous Reading',
      currentReading: 'Current Reading',
      unitPrice: 'Unit Price',
      surcharge: 'Surcharge',
      usage: 'Usage',
      algorithm: 'Algorithm',
      feeBasedOnActual: 'Fee based on actual',
      fixedFee: 'Fixed Fee',
      note1: 'Note: Fees can be paid individually or in batch',
      note2: 'Note: Batch payment is more efficient',
      arrearsSubtotal: 'Arrears Subtotal'
    },
    contractCreateFeeAdd: {
      title: 'Create Fee',
      feeTypeCd: 'Fee Type',
      configId: 'Fee Item',
      amount: 'Amount',
      contractState: 'Contract State',
      startTime: 'Start Time',
      endTime: 'End Time',
      selectFeeType: 'Please select fee type',
      selectFeeConfig: 'Please select fee item',
      inputAmount: 'Please input amount',
      selectStartTime: 'Select start time',
      selectEndTime: 'Select end time',
      state2001: 'Pending Review',
      state2003: 'Under Review',
      state2005: 'Review Completed',
      feeTypeRequired: 'Fee type is required',
      configRequired: 'Fee item is required',
      amountRequired: 'Amount is required',
      startTimeRequired: 'Start time is required',
      endTimeRequired: 'End time is required',
      timeError: 'Start time must be earlier than end time',
      success: 'Successfully created fees. Total: {total}, Success: {success}, Failed: {error}',
      note: 'Note: Batch created fees will be displayed in the contract fee view'
    }
  },
  zh: {
    contractCreateFee: {
      search: {
        title: '查询条件',
        contractCode: '合同编号',
        contractNameLike: '合同名称',
        contractType: '合同类型'
      },
      list: {
        title: '合同信息',
        batchCreate: '批量创建'
      },
      table: {
        contractCode: '合同编号',
        parentContractCode: '父合同编号',
        contractName: '合同名称',
        contractType: '合同类型',
        partyB: '乙方',
        amount: '合同金额',
        startTime: '开始时间',
        endTime: '结束时间',
        operation: '操作',
        payFee: '欠费缴费',
        viewDetail: '详情',
        viewFee: '查看费用'
      },
      fetchError: '获取合同数据失败',
      enterContractCode: '请输入合同编号',
      enterContractName: '请输入合同名称',
      enterContractType: '请输入合同类型',
      enterPartyB: '请输入乙方',
      selectContractStatus: '请选择合同状态',
      batchPayFee: '批量缴费',
      prePayFee: '预付收款',
      batchCreate: '批量创建'
    },
    contractDetailFee: {
      temporaryFee: '临时费用',
      createFee: '创建费用',
      batchPayFee: '批量缴费',
      prePayFee: '预付收款',
      payArrears: '缴费欠费',
      feeItem: '收费项目',
      feeFlag: '费用标识',
      feeType: '费用类型',
      receivableAmount: '应收金额',
      accountingTime: '计费时间',
      receivablePeriod: '应收期间',
      description: '说明',
      status: '状态',
      operation: '操作',
      payment: '缴费',
      paymentHistory: '缴费历史',
      cancel: '取消',
      end: '结束',
      change: '变更',
      previousReading: '上次读数',
      currentReading: '本次读数',
      unitPrice: '单价',
      surcharge: '附加费',
      usage: '用量',
      algorithm: '算法',
      feeBasedOnActual: '按实际收费',
      fixedFee: '固定费用',
      note1: '注：费用可以单独缴费或批量缴费',
      note2: '注：批量缴费更高效',
      arrearsSubtotal: '欠费小计'
    },
    feeDetailContractFeeRule: {
      createFee: '创建费用',
      tempFee: '临时费用',
      ruleId: '规则ID',
      feeItem: '收费项目',
      feeFlag: '费用标识',
      createTime: '创建时间',
      validity: '有效期',
      formula: '公式',
      unitPrice: '单价',
      additionalFee: '附加费',
      status: '状态',
      valid: '有效',
      invalid: '无效',
      billDate: '出账日期',
      billCycle: '出账周期',
      monthly: '按月',
      operation: '操作',
      change: '变更',
      manualFinish: '手动结束',
      cancel: '取消'
    },
    simplifyContractFee: {
      batchPayFee: '批量缴费',
      prePayFee: '预付收款',
      feeItem: '收费项目',
      feeFlag: '费用标识',
      feeType: '费用类型',
      receivableAmount: '应收金额',
      accountingTime: '计费时间',
      receivablePeriod: '应收期间',
      description: '说明',
      status: '状态',
      operation: '操作',
      payment: '缴费',
      paymentHistory: '缴费历史',
      cancel: '取消',
      end: '结束',
      change: '变更',
      previousReading: '上次读数',
      currentReading: '本次读数',
      unitPrice: '单价',
      surcharge: '附加费',
      usage: '用量',
      algorithm: '算法',
      feeBasedOnActual: '按实际收费',
      fixedFee: '固定费用',
      note1: '注：费用可以单独缴费或批量缴费',
      note2: '注：批量缴费更高效',
      arrearsSubtotal: '欠费小计'
    },
    contractCreateFeeAdd: {
      title: '创建费用',
      feeTypeCd: '费用类型',
      configId: '收费项目',
      amount: '收费金额',
      contractState: '合同状态',
      startTime: '计费起始时间',
      endTime: '计费结束时间',
      selectFeeType: '请选择费用类型',
      selectFeeConfig: '请选择收费项目',
      inputAmount: '请填写收费金额',
      selectStartTime: '请填写计费起始时间',
      selectEndTime: '请填写计费结束时间',
      state2001: '待审核',
      state2003: '审核中',
      state2005: '审核完成',
      feeTypeRequired: '费用类型不能为空',
      configRequired: '费用项目不能为空',
      amountRequired: '收费金额不能为空',
      startTimeRequired: '计费起始时间不能为空',
      endTimeRequired: '计费结束时间不能为空',
      timeError: '计费起始时间必须小于计费终止时间',
      success: '创建收费成功，总共[{total}]合同，成功[{success}],失败[{error}]',
note: '注：批量创建的费用在合同收费的查看费用中显示'
    }
  },
  'zh-TW': {
    contractCreateFee: {
      search: {
        title: '查詢條件',
        contractCode: '合同編號',
        contractNameLike: '合同名稱',
        contractType: '合同類型'
      },
      list: {
        title: '合同信息',
        batchCreate: '批量創建'
      },
      table: {
        contractCode: '合同編號',
        parentContractCode: '父合同編號',
        contractName: '合同名稱',
        contractType: '合同類型',
        partyB: '乙方',
        amount: '合同金額',
        startTime: '開始時間',
        endTime: '結束時間',
        operation: '操作',
        payFee: '欠費繳費',
        viewDetail: '詳情',
        viewFee: '查看費用'
      },
      fetchError: '獲取合同數據失敗',
      enterContractCode: '請輸入合同編號',
      enterContractName: '請輸入合同名稱',
      enterContractType: '請輸入合同類型',
      enterPartyB: '請輸入乙方',
      selectContractStatus: '請選擇合同狀態',
      batchPayFee: '批量繳費',
      prePayFee: '預付收款',
      batchCreate: '批量創建'
    },
    contractDetailFee: {
      temporaryFee: '臨時費用',
      createFee: '創建費用',
      batchPayFee: '批量繳費',
      prePayFee: '預付收款',
      payArrears: '繳費欠費',
      feeItem: '收費項目',
      feeFlag: '費用標識',
      feeType: '費用類型',
      receivableAmount: '應收金額',
      accountingTime: '計費時間',
      receivablePeriod: '應收期間',
      description: '說明',
      status: '狀態',
      operation: '操作',
      payment: '繳費',
      paymentHistory: '繳費歷史',
      cancel: '取消',
      end: '結束',
      change: '變更',
      previousReading: '上次讀數',
      currentReading: '本次讀數',
      unitPrice: '單價',
      surcharge: '附加費',
      usage: '用量',
      algorithm: '演算法',
      feeBasedOnActual: '按實際收費',
      fixedFee: '固定費用',
      note1: '注：費用可以單獨繳費或批量繳費',
      note2: '注：批量繳費更高效',
      arrearsSubtotal: '欠費小計'
    },
    feeDetailContractFeeRule: {
      createFee: '創建費用',
      tempFee: '臨時費用',
      ruleId: '規則ID',
      feeItem: '收費項目',
      feeFlag: '費用標識',
      createTime: '創建時間',
      validity: '有效期',
      formula: '公式',
      unitPrice: '單價',
      additionalFee: '附加費',
      status: '狀態',
      valid: '有效',
      invalid: '無效',
      billDate: '出帳日期',
      billCycle: '出帳週期',
      monthly: '按月',
      operation: '操作',
      change: '變更',
      manualFinish: '手動結束',
      cancel: '取消'
    },
    simplifyContractFee: {
      batchPayFee: '批量繳費',
      prePayFee: '預付收款',
      feeItem: '收費項目',
      feeFlag: '費用標識',
      feeType: '費用類型',
      receivableAmount: '應收金額',
      accountingTime: '計費時間',
      receivablePeriod: '應收期間',
      description: '說明',
      status: '狀態',
      operation: '操作',
      payment: '繳費',
      paymentHistory: '繳費歷史',
      cancel: '取消',
      end: '結束',
      change: '變更',
      previousReading: '上次讀數',
      currentReading: '本次讀數',
      unitPrice: '單價',
      surcharge: '附加費',
      usage: '用量',
      algorithm: '演算法',
      feeBasedOnActual: '按實際收費',
      fixedFee: '固定費用',
      note1: '注：費用可以單獨繳費或批量繳費',
      note2: '注：批量繳費更高效',
      arrearsSubtotal: '欠費小計'
    },
    contractCreateFeeAdd: {
      title: '創建費用',
      feeTypeCd: '費用類型',
      configId: '收費項目',
      amount: '收費金額',
      contractState: '合同狀態',
      startTime: '計費起始時間',
      endTime: '計費結束時間',
      selectFeeType: '請選擇費用類型',
      selectFeeConfig: '請選擇收費項目',
      inputAmount: '請填寫收費金額',
      selectStartTime: '請填寫計費起始時間',
      selectEndTime: '請填寫計費結束時間',
      state2001: '待審核',
      state2003: '審核中',
      state2005: '審核完成',
      feeTypeRequired: '費用類型不能為空',
      configRequired: '費用項目不能為空',
      amountRequired: '收費金額不能為空',
      startTimeRequired: '計費起始時間不能為空',
      endTimeRequired: '計費結束時間不能為空',
      timeError: '計費起始時間必須小於計費終止時間',
      success: '創建收費成功，總共[{total}]合同，成功[{success}],失敗[{error}]',
      note: '注：批量創建的費用在合同收費的查看費用中顯示'
    }
  }
}